// Legacy stub. The old ReviewCard rendered legacy contract reviews on
// profile tabs. V2 doesn't model reviews directly (yet); rebuild on the
// new surface in a follow-up. Renders nothing for now.

import React from 'react';

interface ReviewCardProps {
  review?: any;
  reviewerName?: string;
  reviewerAvatar?: string;
}

export const ReviewCard: React.FC<ReviewCardProps> = () => null;
